import { render, staticRenderFns } from "./MedicineInfoDialog.vue?vue&type=template&id=6aa39b67"
import script from "./MedicineInfoDialog.vue?vue&type=script&lang=js"
export * from "./MedicineInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports